import SimpleLayoutContainer from './SimpleLayoutContainer'

export default SimpleLayoutContainer
